import React from "react";

type Props = {};

const ZapReport = (props: Props) => {
  return <div>ZapReport</div>;
};

export default ZapReport;
